export default __webpack_public_path__ + "static/media/bubble-08.9cd82c40.jpg";